<template>
  <el-dialog class="message" title="消息中心" :visible.sync="messageVisible" width="1250px" @closed="onCloseMsg">
    <div class="content flex bg-f3f4f7">
      <div class="flex-3 h-100 flex-column">
        <div class="title plr-20 flex align-center mtb-10">
          <div class="flex align-center mr-20 cursor" v-for="(item, index) in tab" :key="index" @click="switchTab(index + 1)">
            <div class="mr-5" :class="index + 1 === tabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
            <div class="font-bold" :class="index + 1 === tabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{item}}</div>
          </div>
        </div>
        <div class="list flex-1 h-0">
          <el-scrollbar style="height: 100%;">
            <div class="flex mlr-20 align-center justify-space-between bg-ff mb-10 text-left p-10 listItem" v-for="(item, index) in messageList" :key="index">
              <div>
                <div class="font-12-85"><i>{{item.type === 1 ? '收款': item.type === 2 ? '付款' : item.type === 3 ? '投诉' : item.type === 4 ? '回访' : item.type === 5 ? '维修' : item.type === 6 ? '计划' : item.type === 7 ? '指派':'其他'}}</i> {{Utils.formatTime(item.remindTime)}}</div>
                <div class="font-12-30313a">{{item.content}}</div>
              </div>
              <div class="btn-16-bd-46b8b0" @click="isRead(item.id)" v-if="tabIndex === 1">标为已读</div>
              <!-- <i class="el-icon-arrow-right" style="color: #30313a"></i> -->
            </div>
          </el-scrollbar>
        </div>
        <div class="m-20">
          <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
        </div>
      </div>
      <!-- <div class="line"></div>
      <div class="flex-1 h-100 flex-column">
        <div class="title mlr-20 flex align-center mtb-10">
          <div class="flex align-center mr-20 cursor">
            <div class="mr-5 decoration-line"></div>
            <div class="font-bold font-16-46b8b0">公司公告</div>
          </div>
        </div>
        <div class="list flex-1 h-0">
          <el-scrollbar style="height: 100%;">
            <div class="mlr-20 bg-ff mb-10 text-left p-10 listItem" v-for="(item, index) in noticeList" :key="index">
              <div class="font-14-30313a">{{item.name}}</div>
              <div class="font-12-b9b9b9">{{Utils.formatTime(item.createTime)}}</div>
              <div class="font-12-85 text-hidden">{{item.content}}</div>
              <div class="text-right mt-10">
                <button class="button font-bold" @click="onMore(item)">···</button>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div> -->
    </div>
    <el-dialog
      class="text-center inline"
      width="650px"
      title="公告详情"
      :visible.sync="detailVisible"
      append-to-body>
      <div class="flex detail">
        <div class="flex-3 text-left h-100 text ptb-20">
          <el-scrollbar style="height: 100%;">
            <div class="plr-20">
              <div class="font-18-30313a mb-2 font-bold">{{currentNotice.name}}</div>
              <div class="font-12-b9b9b9 mb-18">{{Utils.formatTime(currentNotice.createTime)}}</div>
              <div class="font-12-424142 lh-18">{{currentNotice.content}}</div>
            </div>
          </el-scrollbar>
        </div>
        <div class="line"></div>
        <div class="flex-1 flex-column h-100 align-center justify-center">
          <a :href="Utils.IMG_PREV + currentNotice.file" target="_blank" class="flex-column align-center" v-if="currentNotice.file">
            <img :src="currentNotice.file ? getEnclosureTypeImg(currentNotice.file) : '/static/images/addFile.png'" class="type-img" alt="">
            <div class="flex align-center mt-10 cursor">
              <div class="font-12-30313a mr-5">下载附件</div>
              <img src="/static/images/xiazai.png" alt="">
            </div>
          </a>
          <div class="flex-column align-center" v-else>
            <img :src="currentNotice.file ? getEnclosureTypeImg(currentNotice.file) : '/static/images/addFile.png'" class="type-img" alt="">
            <div class="font-12-30313a mt-10" >暂无附件</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import Pagination from './Pagination'
export default {
  name: 'Message',
  components: {Pagination},
  data () {
    return {
      messageVisible: false,
      detailVisible: false,
      tab: ['新消息', '已读消息'],
      tabIndex: 1,
      messageList: [],
      noticeList: [1, 1, 1],
      currentNotice: {},
      flag: true,
      page: 1,
      limit: 25,
      pageSize: 0,
      pageNo: 0,
      pageTotal: 25,
      total: 0
    }
  },
  created () {
    // if (this.$store.state.isNotice === 1) {
    //   this.messageVisible = true
    // }
    this.getNotice()
    console.log(this.$parent.$refs.message)
  },
  watch: {
    messageVisible (val) {
      if (val) {
        this.getNotice()
      }
    }
  },
  mounted () {
  },
  methods: {
    switchTab (index) {
      this.tabIndex = index
      this.getNotice()
    },
    onMore (item) {
      this.detailVisible = true
      this.currentNotice = item
    },
    getEnclosureTypeImg (path) {
      if (path) {
        let type = path.substring(path.lastIndexOf('.') + 1)
        switch (type.toLowerCase()) {
          case 'doc':
          case 'docx':
            return '/static/images/word.png'
          case 'pdf':
            return '/static/images/pdf.png'
          case 'ppt':
            return '/static/images/ppt.png'
          case 'xls':
          case 'xlsx':
            return '/static/images/excel.png'
          case 'dwg':
            return '/static/images/cad.png'
          case 'txt':
            return '/static/images/txt.png'
          default:
            return '/static/images/other.png'
        }
      }
    },
    onCloseMsg () {
      this.$store.dispatch('setNotice', 2)
      console.log(this.$store.state.isNotice)
      this.messageVisible = false
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getNotice()
    },
    getNotice () {
      this.messageList = []
      let param = {
        page: this.page,
        limit: this.limit,
        remindId: this.$store.state.user.id,
        remindType: 1,
        isRead: this.tabIndex === 1 ? 0 : 1,
        status: 1
      }
      this.axios.post('message/queryForPage', param).then(res => {
        if (res.data.success) {
          this.messageList = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
          if (this.page === 1 & this.tabIndex === 1 && this.messageList.length > 0) {
            this.messageVisible = true
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },
    isRead (id) {
      let that = this
      let param = {
        id: id,
        isRead: 1
      }
      this.axios.post('message/modify', param).then(res => {
        if (res.data.success) {
          this.getNotice()
          that.$parent.$refs.nar.getMessage()
          // this.$parent.$parent.getMessage()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #46b8b0;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .message /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
  .inline /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
  .content{
    height: 600px;
  }
  .detail{
    height: 350px;
  }
  .line{
    width: 1px;
    height: 100%;
    background: #e2e2e2;
  }
  .overflow-y{
    overflow-y: auto;
  }
  .list /deep/ .el-scrollbar__wrap, .text /deep/ .el-scrollbar__wrap{
    overflow-x: hidden;
  }
  .list i{
    font-size: 12px;
    color: #b9b9b9;
    font-style: normal;
  }
  .list span{
    font-size: 12px;
    color: #858585;
  }
  .listItem{
    border-radius: 4px;
  }
  .text-hidden{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .button{
    width: 30px;
    height: 15px;
    background-color: #ffffff;
    border-radius: 4px;
    border: solid 1px #e2e2e2;
    color: #858585;
    line-height: 14px;
    cursor: pointer;
  }
  .button:hover{
    background-color: #46b8b0;
    color: #fff;
    border-color: #46b8b0;
  }
  .lh-18{
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Message.vue